/**
 * BargainRanger — shared homepage product rail controller
 * Native overflow-x scroll + arrow controls. NO autoplay.
 * Used by commerce hero aisle + Featured Deals (and any [data-br-product-rail]).
 */
(function () {
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRail(root) {
    if (!root || root.dataset.brRailReady === '1') return;
    const viewport = root.querySelector('[data-br-rail-viewport]');
    const track = root.querySelector('[data-br-rail-track]');
    const prev = root.querySelector('[data-br-rail-prev]');
    const next = root.querySelector('[data-br-rail-next]');
    const nav = root.querySelector('[data-br-rail-nav]');
    if (!viewport || !track) return;

    root.dataset.brRailReady = '1';

    function itemSelector() {
      return (
        root.getAttribute('data-br-rail-item') ||
        '.br-commerce-deal__item, .br-deal-card__item, .br-product-carousel__item, .br-new-arrivals__item, li'
      );
    }

    function getScrollAmount() {
      const item = track.querySelector(itemSelector());
      if (!item) return Math.max(viewport.clientWidth * 0.8, 160);
      const style = getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap) || 12;
      // Advance ~1 card; keep dense shelves predictable
      return item.getBoundingClientRect().width + gap;
    }

    function updateNav() {
      const maxScroll = viewport.scrollWidth - viewport.clientWidth;
      const needsNav = maxScroll > 8;
      if (nav) nav.hidden = !needsNav;
      if (prev) prev.disabled = !needsNav || viewport.scrollLeft <= 4;
      if (next) next.disabled = !needsNav || viewport.scrollLeft >= maxScroll - 4;
    }

    function scrollByDir(dir) {
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const amount = getScrollAmount() * dir;
      let target = viewport.scrollLeft + amount;
      if (dir > 0) target = Math.min(target, maxScroll);
      if (dir < 0) target = Math.max(target, 0);
      viewport.scrollTo({
        left: target,
        behavior: REDUCED_MOTION ? 'auto' : 'smooth'
      });
    }

    prev?.addEventListener('click', function (e) {
      e.preventDefault();
      scrollByDir(-1);
    });
    next?.addEventListener('click', function (e) {
      e.preventDefault();
      scrollByDir(1);
    });

    viewport.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);

    viewport.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollByDir(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        scrollByDir(1);
      }
    });

    // Recalc after images settle so last card is reachable / nav visibility correct
    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(updateNav);
      ro.observe(viewport);
      ro.observe(track);
    }
    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', updateNav, { once: true });
    });

    updateNav();
    requestAnimationFrame(updateNav);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-br-product-rail]').forEach(initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
